import { createContext, useContext } from "react";
import {
  Connection,
  Edge,
  Node,
  OnEdgesChange,
  OnNodesChange,
} from "reactflow";
import { FilterOptionSchema } from "../components/Filter/filter.data";
import { WorkFlowStage } from "../models/Workflow";

export type IWorkFlowBasicInfo = {
  name: string;
  owner: FilterOptionSchema;
  description: string;
  attachments: File[];
  initAttachments: { id: number; name: string }[];
  guidelines: string;
  form: FilterOptionSchema;
  published: boolean;
};

export type IWorkFlowContext = {
  nodes: Node[];
  edges: Edge[];
  info: IWorkFlowBasicInfo;
  teamList: FilterOptionSchema[];
  addNodes: (node: Node) => void;
  onConnect: (params: Edge | Connection) => void;
  updateInfo: (key: string, value: any) => void;
  onNodesChange?: OnNodesChange;
  onEdgesChange?: OnEdgesChange;
  nodeDetails: { [key: number]: WorkFlowStage };
  updateNodeDetails: (data: WorkFlowStage) => void;
  saveWorkflow: (publish: boolean) => void;
  selectedNode?: number;
  setSelectedNode?: (id: number) => void;
};

export const INIT_WORKFLOW_INFO = {
  name: "",
  owner: { id: -1, name: "" },
  description: "",
  attachments: [],
  initAttachments: [],
  guidelines: "",
  form: { id: -1, name: "" },
  published: false,
};

export const WorkFlowContext = createContext<IWorkFlowContext>({
  nodes: [],
  edges: [],
  teamList: [],
  info: INIT_WORKFLOW_INFO,
  addNodes: (node: Node) => {},
  onConnect: (params: Edge | Connection) => {},
  updateInfo: (key: string, value: any) => {},
  nodeDetails: {},
  updateNodeDetails: (data: WorkFlowStage) => {},
  saveWorkflow: (publish: boolean) => {},
});

export const useWorkFlowContext = () => useContext(WorkFlowContext);
